export default {"src":"/pro/_next/static/media/xrp.a69dd461.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};